module.exports = require('./helpers/bundle-url').getBundleURL('bu0dN') + "51453ff801875_002.c2a94a25.png";